/**
 * Resolves special @-prefixed value tokens to runtime values.
 *
 * Tokens: @today, @now, @currentUser, @previousValue, @triggerItem
 */

export interface TokenResolutionContext {
  currentUser?: string;
  previousValue?: unknown;
  triggerRecord?: Record<string, unknown>;
}

export function resolveSpecialToken(
  token: unknown,
  context: TokenResolutionContext,
): unknown {
  if (typeof token !== 'string' || !token.startsWith('@')) {
    return token;
  }

  switch (token) {
    case '@today':
      return new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    case '@now':
      return new Date().toISOString();
    case '@currentUser':
      return context.currentUser;
    case '@previousValue':
      return context.previousValue;
    case '@triggerItem':
      return context.triggerRecord;
    default:
      console.warn(`[AutomationRules] Unknown special token: "${token}"`);
      return token;
  }
}
